import { ExecutionHistoryDetailRecordModified } from '@/pages/hes/command/includes/utils';
import Navigator from '../Navigator';
import { FC, useState } from 'react';
import useGetTableColumns from '@/hooks/useGetTableColumns';
import DataTable from '@/components/customUI/DataTable';
import { ObisCodeMapType } from '@/store/hes/types/other';

type CommandResponseForAllEventPullProps = {
  data: ExecutionHistoryDetailRecordModified | undefined;
  obisCodeMap: ObisCodeMapType;
  failedReason?: string;
  keyOrder?: string[];
};

const CommandResponseForAllEventPull: FC<
  CommandResponseForAllEventPullProps
> = ({ data, obisCodeMap, keyOrder, failedReason }) => {
  const navigationKeys = data && Object.keys(data);
  const [activeKey, setActiveKey] = useState(
    (navigationKeys && navigationKeys[0]) || ''
  );
  const dataForTable = data && data[activeKey];

  const columns = useGetTableColumns({
    cols: (!failedReason && dataForTable) || [],
    query: ['data_type']
  });
  if (failedReason) {
    return <div className="border rounded text-center p-5">{failedReason}</div>;
  }
  return (
    <div className="grid md:grid-cols-[250px_1fr] grid-cols-1 md:grid-rows-[auto_1fr] gap-4 h-full p-4 ">
      <Navigator
        isAllEventPullCommand={true}
        navigationKeys={navigationKeys || []}
        activeKey={activeKey}
        setActiveKey={setActiveKey}
      />
      <div className="col-span-1 w-full overflow-x-auto scrollbar-custom">
        <div className="w-full h-[350px]">
          <DataTable
            columnOrder={keyOrder}
            obisCodeMap={obisCodeMap}
            hasInternalPagination
            columns={columns}
            data={dataForTable || []}
          />
        </div>
      </div>
    </div>
  );
};

export default CommandResponseForAllEventPull;
